/* eslint-env browser */

import * as React from 'react'

require('../../../container/client')

const ReactDOM = require('react-dom')
const DomHelper = require('../../../client/clientjs/dom-helper')
const SearchBrands = require('../../../client/clientjs/components/search/SearchBrands')

DomHelper.onDocumentReady(() => {
  const renderSearchBrandsElt = DomHelper.query('#react-render-brands')
  if (renderSearchBrandsElt) {
    ReactDOM.hydrate(
      <SearchBrands
        locale={window.initialState.locale.identifierShort}
        brands={window.initialState.brands}
        perPage={window.initialState.search.perPage}
        page={window.initialState.search.page}
        query={window.initialState.search.query}
        totalCount={window.initialState.search.totalCount}
        host={window.initialState.config.host}
      />,
      renderSearchBrandsElt
    )
  }
})

if (module.hot) {
  module.hot.accept()
}
